/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type FolderChatStatus = typeof FolderChatStatus[keyof typeof FolderChatStatus];


export const FolderChatStatus = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  COPYING: 'COPYING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
  UPDATING: 'UPDATING',
} as const;
